import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgArrowUpFromBracket = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M18.941 14.249c.46 0 .833.378.833.843v2.532c0 1.865-1.491 3.376-3.332 3.376H7.557c-1.84 0-3.331-1.511-3.331-3.376v-2.531c0-.468.372-.844.833-.844s.833.378.833.843v2.532c0 .929.75 1.688 1.665 1.688h8.885c.917 0 1.666-.76 1.666-1.688v-2.531c0-.468.372-.844.833-.844m-7.51-11.023-4.72 4.47c-.338.35-.353.884-.038 1.222a.824.824 0 0 0 1.177.036l3.317-3.16v8.734c0 .47.375.846.833.846a.833.833 0 0 0 .833-.812V5.794l3.316 3.162a.824.824 0 0 0 1.177-.036.854.854 0 0 0-.035-1.193l-4.72-4.47a.793.793 0 0 0-1.14-.03"
    }));
export default SvgArrowUpFromBracket;
